import { defineStore } from 'pinia'
import { ref } from 'vue'
import request from '@/utils/request'
import { useAuthStore } from '@/stores/auth'

/**
 * 通知未读数 store：集中维护未读数量，全局单例轮询，避免 TopNav 与 Notifications 重复请求
 */
export const useNotificationStore = defineStore('notification', () => {
  const unreadCount = ref(0)
  let pollTimer = null
  const POLL_INTERVAL = 5000

  async function fetchUnreadCount() {
    const authStore = useAuthStore()
    if (!authStore.user) return unreadCount.value
    try {
      const count = await request.get('/notifications/unread-count')
      unreadCount.value = typeof count === 'number' ? count : (count || 0)
      return unreadCount.value
    } catch (error) {
      console.error('获取未读通知数量失败:', error)
      return unreadCount.value
    }
  }

  function startPolling() {
    stopPolling()
    const tick = async () => {
      if (document.visibilityState === 'hidden') return
      await fetchUnreadCount()
    }
    tick()
    pollTimer = setInterval(tick, POLL_INTERVAL)
  }

  function stopPolling() {
    if (pollTimer) {
      clearInterval(pollTimer)
      pollTimer = null
    }
  }

  function setUnreadCount(count) {
    unreadCount.value = Math.max(0, count)
  }

  return {
    unreadCount,
    fetchUnreadCount,
    startPolling,
    stopPolling,
    setUnreadCount
  }
})
